/**
 * API Configuration - FutJá Admin Panel
 *
 * Configuração simples do Axios (igual ao app mobile)
 */
import axios from 'axios'

// A API roda na porta 3001 (ou variável de ambiente)
// REACT_APP_API_URL é definido nos scripts do package.json a partir de EXPO_PUBLIC_API_URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'
console.log('🌐 [API] Base URL:', API_BASE_URL)

/**
 * Instância principal do Axios
 */
const api = axios.create({
	baseURL: API_BASE_URL,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json',
	},
})

/**
 * Inicializa o token do localStorage no header da API
 * Deve ser chamado no início do app
 */
export const initializeAuth = () => {
	const token = localStorage.getItem('admin_token')
	if (token) {
		api.defaults.headers.Authorization = `Bearer ${token}`
		return true
	}
	return false
}

/**
 * Define o token de autenticação
 */
export const setAuthToken = (token) => {
	if (token) {
		localStorage.setItem('admin_token', token)
		api.defaults.headers.Authorization = `Bearer ${token}`
	} else {
		localStorage.removeItem('admin_token')
		delete api.defaults.headers.Authorization
	}
}

/**
 * Remove o token de autenticação
 */
export const clearAuthToken = () => {
	localStorage.removeItem('admin_token')
	delete api.defaults.headers.Authorization
}

/**
 * Interceptor de Response - apenas para log e tratamento de 401
 */
api.interceptors.response.use(
	(response) => {
		if (process.env.NODE_ENV === 'development') {
			console.log('🌐 [API] Response:', response.config.url, response.data)
		}
		return response
	},
	(error) => {
		if (process.env.NODE_ENV === 'development') {
			console.error('🔴 [API] Error:', error.config?.url, error.response?.status, error.response?.data)
		}

		// Se 401, limpa o token (será tratado pelo checkAuth)
		if (error.response?.status === 401) {
			clearAuthToken()
		}

		return Promise.reject(error)
	}
)

/**
 * Formata URL de imagem para usar o proxy da API
 * Se a URL já for completa (http/https), retorna como está
 * Se for uma key S3, formata para usar o endpoint /image/
 * @param {string} imageKey - Key da imagem no S3 ou URL completa
 * @returns {string|null} - URL formatada ou null se não houver imagem
 */
export const formatImageUrl = (imageKey) => {
	if (!imageKey) return null

	// Se já é uma URL completa, retorna como está
	if (imageKey.startsWith('http://') || imageKey.startsWith('https://')) {
		return imageKey
	}

	// Se é uma key S3, formata para usar o proxy da API
	return `${API_BASE_URL}/image/${imageKey}`
}

export { api, API_BASE_URL }
export default api
